import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Layout from '../components/Layout';

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Hasła nie są identyczne');
      return;
    }

    if (formData.password.length < 8) {
      setError('Hasło musi mieć co najmniej 8 znaków');
      return;
    }

    setLoading(true);

    try {
      await register(
        formData.firstName,
        formData.lastName,
        formData.email,
        formData.password,
        formData.confirmPassword
      );
      // Po rejestracji pokaż komunikat o emailu aktywacyjnym
      setError('');
      alert('Konto zostało utworzone! Sprawdź email w celu aktywacji konta.');
      navigate('/login');
    } catch (err) {
      console.error('Błąd rejestracji:', err.response?.data);
      // Wyświetl bardziej szczegółowe błędy
      const errorMessages = [];
      if (err.response?.data) {
        Object.keys(err.response.data).forEach(key => {
          const errors = err.response.data[key];
          if (Array.isArray(errors)) {
            errorMessages.push(...errors.map(e => `${key}: ${e}`));
          } else if (typeof errors === 'string') {
            errorMessages.push(errors);
          } else if (typeof errors === 'object') {
            errorMessages.push(`${key}: ${JSON.stringify(errors)}`);
          }
        });
      }
      setError(
        errorMessages.length > 0 
          ? errorMessages.join('. ')
          : err.response?.data?.detail ||
            err.response?.data?.email?.[0] ||
            'Błąd rejestracji. Spróbuj ponownie.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-ik-black">
              Utwórz nowe konto
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Lub{' '}
              <Link
                to="/login"
                className="font-medium text-ik-orange hover:text-orange-600"
              >
                zaloguj się do istniejącego konta
              </Link>
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            {error && (
              <div className="bg-red-50 border border-red-400 text-red-700 px-4 py-3 rounded">
                {error}
              </div>
            )}
            <div className="rounded-md shadow-sm space-y-4">
              <div>
                <label htmlFor="firstName" className="sr-only">
                  Imię
                </label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  required
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange focus:z-10 sm:text-sm"
                  placeholder="Imię"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="lastName" className="sr-only">
                  Nazwisko
                </label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  required
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange focus:z-10 sm:text-sm"
                  placeholder="Nazwisko"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange focus:z-10 sm:text-sm"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Hasło
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange focus:z-10 sm:text-sm"
                  placeholder="Hasło"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="confirmPassword" className="sr-only">
                  Powtórz hasło
                </label>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  required
                  className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange focus:z-10 sm:text-sm"
                  placeholder="Powtórz hasło"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-ik-orange hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ik-orange disabled:opacity-50"
              >
                {loading ? 'Rejestracja...' : 'Zarejestruj się'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Register;
